/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "path"] }] */
import { createAction, createReducer } from '@reduxjs/toolkit';
import produce from 'immer';

import {
  WIZARD_PATHS,
  WIZARD_FORWARD,
  WIZARD_BACK,
  WIZARD_UPDATE_PATH,
  WIZARD_UPDATE_FORWARD,
  WIZARD_UPDATE_BACK,
} from '../constants/actionTypes';
import wizardConfig from '../lib/wizard/wizardConfig';
import {
  findByUrl,
  findPathObject,
  nextPathObject,
  previousPathObject,
} from '../lib/wizard/wizardPathHelpers';

export const initialState = {
  currentPath: '',
  currentPathObject: {},
  paths: [],
};

const wizardPaths = () => {
  return {
    paths: wizardConfig,
    currentPath: wizardConfig[0].url,
    currentPathObject: wizardConfig[0],
  };
};

const wizardForwards = state => {
  const { currentPath, paths } = state;
  state.currentPath = nextPathObject(currentPath, paths).url;
  state.currentPathObject = nextPathObject(currentPath, paths);
};

const wizardBack = state => {
  const { currentPath, paths } = state;
  state.currentPath = previousPathObject(currentPath, paths).url;
  state.currentPathObject = previousPathObject(currentPath, paths);
};

const wizardUpdatePath = (state, action) => {
  const newPathObject = findPathObject(action.payload, state.paths);
  state.currentPath = action.payload;
  state.currentPathObject = newPathObject;
};

const insertNewPaths = paths => {
  return produce(paths, draft => {
    draft.forEach((path, i) => {
      if (i === 0) {
        path.appendedFirst = true;
      }
      path.appended = true;
    });
  });
};

const resetFuturePaths = paths => {
  if (paths[0] && paths[0].appendedFirst) {
    return paths.filter((path, i) => !(path.appended === true));
  }
  return paths;
};

const wizardUpdateForward = (state, action) => {
  const { currentUrl, flag } = action.payload;
  const index = findByUrl(currentUrl, state.paths);
  const newPaths = state.paths[index][flag];
  const pathsToCurrent = state.paths.slice(0, index + 1);
  const pathsAfterCurrent = state.paths.slice(index + 1);
  state.paths = [
    ...pathsToCurrent,
    ...insertNewPaths([...newPaths]),
    ...resetFuturePaths(pathsAfterCurrent),
  ];
};

const wizardUpdateBack = (state, action) => {
  const { paths } = state;
  const index = findByUrl(action.payload, paths);
  if (paths[index] && paths[index].appendedFirst === true) {
    state.paths = [...state.paths.filter((path, i) => !(path.appended === true && i >= index))];
  }
};

const wizardProgress = createReducer(initialState, builder => {
  builder
    .addCase(createAction(WIZARD_PATHS), wizardPaths)
    .addCase(createAction(WIZARD_FORWARD), wizardForwards)
    .addCase(createAction(WIZARD_BACK), wizardBack)
    .addCase(createAction(WIZARD_UPDATE_PATH), wizardUpdatePath)
    .addCase(createAction(WIZARD_UPDATE_FORWARD), wizardUpdateForward)
    .addCase(createAction(WIZARD_UPDATE_BACK), wizardUpdateBack);
});

export default wizardProgress;
